import React from 'react'

import cartoonAroony from '../../images/CARTOONAROONY.JPG'
import cartoonAroony2 from '../../images/CARTOONAROONY 2.JPG'
import cartoonAroony3 from '../../images/CARTOONAROONY 3.JPG'
import cartoonAroony4 from '../../images/CARTOONAROONY 4.JPG'
import cartoonAroony6 from '../../images/CARTOONAROONY 6.JPG'

function CartoonAroony() {
  return (
    <div className="Project-page container">
      <div className="row">
        <div className="col-md-6">
          <img
            src={cartoonAroony}
            className="project-image" />
          <img
            src={cartoonAroony2}
            className="project-image" />
          <img
            src={cartoonAroony3}
            className="project-image" />
          <img
            src={cartoonAroony4}
            className="project-image" />
          <img
            src={cartoonAroony6}
            className="project-image" />
        </div>
        <div className="Project-content col-md-6">
          <h1>Cartoonaroony</h1>
          <p className="Project-text">
            <strong>
              Created and performed by:
            <br />
            Ella Gilbert
            <br />
            Chris Jannides
            <br />
            Frankie Berge
            <br />
            Grace Bentley Tsibuah
            <br />
            featuring Peter Zazzali
            </strong>
          </p>
          <p className="Project-testimonial">
            NZ FRINGE FESTIVAL, 2019
            <br />
            Nominations:
            <br />
            OUTSANDING PERFORMER - Ella Gilbert
            <br />
            MOST PROMISING EMERGING ARTIST - Ella Gilbert
          </p>
          <p className="Project-testimonial">
            "Simultaneously strange and familiar.
            <br />
            As an exploration of form, it’s a riot. And – responding to a question raised in the programme note, it does have the potential to comment on “human life and its complexities, celebrations, insights or issues.” I look forward to what develops.”
          </p>
          <h6 className="Testimonial-person">
            <strong>~Theatreview</strong>
          </h6>
          <br />
          <p className="Project-text">
            ~ Manifesto: we could do a show called 'cartoonaroony' and it can be in the new style of cartoon theatre which has never been done before ~
            <br />
            A rollercoaster of eclectic happenings.
            <br />
            A cabinet of meaningless movement.
            <br />
            A silly dance.
            <br />
            An animated chaotic elasticity of body and thought produced by the warping and distorting of imagination. A rollicking sketch show jig sawed together in rousing ways, like a really good pick n mix.
          </p>
        </div>
      </div>
    </div>
  )
}

export default CartoonAroony
